import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PATHS from '../../Routers/PATHS';

export default (ChildComponent) => {

    const RequireAuth = (props) => {

        switch (props.user) {
            case null:
            case "":
                return <Redirect to={PATHS.SIGNIN.URL} />;
            default:
                return <ChildComponent {...props} />;
        };
    };

    const mapStateToProps = ({ auth }) => {
        const { user } = auth;
        return { user };
    };

    return connect(mapStateToProps, {})(RequireAuth);
};